<template>
  <div class="company-name-info">
    <div v-if="assignment.senderAddress?.companyName">
      <span v-b-tooltip="{ title: assignment.company.name || assignment.company.shortName }">
        {{ assignment.senderAddress.companyName }}
      </span>
    </div>
    <div v-else-if="assignment.company.shortName">
      <span v-b-tooltip="{ title: assignment.company.name }">
        {{ assignment.company.shortName }}
      </span>
    </div>
    <div v-else>
      {{ assignment.company.name }}
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'CustomerCell',
  props: {
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
  },
})
</script>
